module.exports = __webpack_public_path__ + "img/1505739280.51d62930.jpg";